module.exports = __webpack_public_path__ + "static/media/radu_puchiu.697db486.png";